import { cache as cachePlugin, createClient, dedup as dedupPlugin, definePlugin, fetch as fetchPlugin } from 'villus';
import { logError } from '@utils/error-tracking';
import { SANITY_PROJECT_ID } from '@constants/sanity';
import type { FetchOptions } from 'villus';

function getSanityGraphQLUrl(): string {
	const environment = import.meta.env.VITE_SANITY_ENV;
	const graphqlTag = import.meta.env.VITE_SANITY_GRAPHQL_TAG;

	return `https://${SANITY_PROJECT_ID}.apicdn.sanity.io/v2023-08-01/graphql/${environment}/${graphqlTag}`;
}

const errorHandlerPlugin = definePlugin(({ afterQuery }) => {
	afterQuery(({ error }) => {
		if (error) {
			logError(error, 'error', {
				key: 'GraphQL query error',
				data: {
					response: error?.response,
					message: error?.message,
					graphqlErrors: error?.graphqlErrors ?? []
				}
			});
			const accessDeniedGraphQL =
				error?.isGraphQLError &&
				error.graphqlErrors?.some((err) => err.message.toLowerCase().includes('access denied'));
			// Keeping this as a placeholder logic
			// Update the logic below to handle error cases better once we get more context around hidden fields
			if (accessDeniedGraphQL || error?.response?.status === 401) {
				window.location.href = '/login';
			}
		}
	});
});

export const villusClient = createClient({
	url: getSanityGraphQLUrl(),
	use: [
		function authPlugin({ opContext }: { opContext: FetchOptions }) {
			opContext.headers.Authorization = `Bearer ${import.meta.env.VITE_SANITY_TOKEN}`;
		},
		cachePlugin(),
		errorHandlerPlugin,
		dedupPlugin(),
		fetchPlugin()
	]
});
